import {ConfirmationResult} from "firebase/auth";

import {AuthenticationRepository} from "../../../repositories/AuthenticationRepository";

export class ConfirmPhoneVerificationCodeUseCase {
  constructor(private readonly repository: AuthenticationRepository) {}

  confirmPhoneVerificationCode(confirmationResult: ConfirmationResult, code: string) {
    return this.repository.confirmPhoneVerificationCode(confirmationResult, code)
  }
}
